/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Creation
 * 1 = Modification
 * 2 = Suppression
 * 3 = Desactivation
 */
export enum EvenementWebhook {
  Creation = 0,
  Modification = 1,
  Suppression = 2,
  Desactivation = 3
}
